import * as React from "react";

import { Box, Fade } from "@material-ui/core";

import { useOnboardingStatusContext, useTimeout } from "client/hooks";
import { OnboardingStep } from "client/pages/OnboardingStatus/utils";
import { isRunningJest } from "client/utils";

import { Status } from "./types";

export const StatusStep: React.FC<{
  children: React.ReactElement<any, any>;
  timeToFade: number;
  activeOnboardingStep?: OnboardingStep;
  stepStatus?: Status;
}> = ({ children, timeToFade, activeOnboardingStep, stepStatus }) => {
  const initialRender = React.useRef<boolean>();
  const [fadeIn, setFadeIn] = React.useState(false);

  const { onActiveOnboardingStepUpdated } = useOnboardingStatusContext();

  const mouseEnterFunc = () =>
    onActiveOnboardingStepUpdated(
      stepStatus === "InProgress" ? activeOnboardingStep : undefined
    );

  if (isRunningJest()) {
    // set to 0 so we don't have to include artificial timeouts during testing
    timeToFade = 0;
  }

  useTimeout(() => {
    if (!initialRender.current) {
      initialRender.current = true;
      setFadeIn(true);
    }
  }, timeToFade);
  return (
    <Box
      onMouseEnter={mouseEnterFunc}
      onMouseLeave={() => onActiveOnboardingStepUpdated(undefined)}
    >
      <Fade in={fadeIn} timeout={1000}>
        {children}
      </Fade>
    </Box>
  );
};
